import "./src/styles/global.css"
require("prismjs/plugins/line-numbers/prism-line-numbers.css")
